/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncReducer } from 'ui-rating-review/src/utils/async_utils';
import {
    FETCH_GATEWAY_TICKET_SEARCH_START,
    FETCH_GATEWAY_TICKET_SEARCH_SUCCESS,
    FETCH_GATEWAY_TICKET_SEARCH_FAILURE,
    FETCH_GATEWAY_POI_SEARCH_FAILURE,
    FETCH_GATEWAY_POI_SEARCH_START,
    FETCH_GATEWAY_POI_SEARCH_SUCCESS,
    FETCH_GATEWAY_SEARCH_FAILURE,
    FETCH_GATEWAY_SEARCH_START,
    FETCH_GATEWAY_SEARCH_SUCCESS,
    FETCH_GATEWAY_CAMPING_SEARCH_FAILURE,
    FETCH_GATEWAY_CAMPING_SEARCH_START,
    FETCH_GATEWAY_CAMPING_SEARCH_SUCCESS,
    FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_START,
    FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_SUCCESS,
    FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_FAILURE,
    FETCH_GATEWAY_TREE_PERMITS_SEARCH_START,
    FETCH_GATEWAY_TREE_PERMITS_SEARCH_SUCCESS,
    FETCH_GATEWAY_TREE_PERMITS_SEARCH_FAILURE,
    FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_START,
    FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_SUCCESS,
    FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_FAILURE,
    FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_START,
    FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_SUCCESS,
    FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_FAILURE,
} from '../../constants/types';

export const fetchCampingSearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_CAMPING_SEARCH_START,
        successType: FETCH_GATEWAY_CAMPING_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_CAMPING_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchTicketSearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_TICKET_SEARCH_START,
        successType: FETCH_GATEWAY_TICKET_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_TICKET_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchPOISearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_POI_SEARCH_START,
        successType: FETCH_GATEWAY_POI_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_POI_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchGatewaySearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_SEARCH_START,
        successType: FETCH_GATEWAY_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchActivityPassesSearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_START,
        successType: FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_ACTIVITY_PASSES_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchTreePermitsSearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_TREE_PERMITS_SEARCH_START,
        successType: FETCH_GATEWAY_TREE_PERMITS_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_TREE_PERMITS_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchVenueReservationSearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_START,
        successType: FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_VENUE_RESERVATIONS_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchVenueFacilitySearch = makeAsyncReducer(
    {
        startType: FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_START,
        successType: FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_SUCCESS,
        failureType: FETCH_GATEWAY_VENUE_FACILITIES_SEARCH_FAILURE,
    },
    { initialData: {} }
);

export const fetchCampingSearchSelector = (state) => state.newGateway.fetchCampingSearch;
export const fetchTicketSearchSelector = (state) => state.newGateway.fetchTicketSearch;
export const fetchPOISearchSelector = (state) => state.newGateway.fetchPOISearch;
export const fetchGatewaySearchSelector = (state) => state.newGateway.fetchGatewaySearch;
export const fetchActivityPassesSearchSelector = (state) =>
    state.newGateway.fetchActivityPassesSearch;
export const fetchTreePermitsSearchSelector = (state) =>
    state.newGateway.fetchTreePermitsSearch;
export const fetchVenueReservationSelector = (state) =>
    state.newGateway.fetchVenueReservationSearch;
export const fetchVenueFacilitySelector = (state) =>
    state.newGateway.fetchVenueFacilitySearch;
